<template>
  <!-- 标签选择器 -->
  <div
    v-if="options.length >= 1"
    class="tag-selector flex space-x-[12px] overflow-x-auto pb-[8px] [scrollbar-width:none] max-w-[670px]"
  >
    <button
      v-for="option in options"
      :key="option.value"
      class="h-[62px] px-[50px] py-[8px] rounded-[100px] text-[30px] text-center font-normal whitespace-nowrap transition-all"
      :class="
        currentValue === option.value
          ? 'bg-[#FF6900] text-white border-solid border-[1.6px] border-[#FF6900]'
          : 'bg-white text-[#FF6900] border-solid border-[1.6px] border-[#FF6900]'
      "
      @click="handleSelect(option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
interface TagOption {
  label: string;
  value: string;
}
interface Props {
  /** 标签选项列表 */
  options: TagOption[];
  /** 当前选中的值（v-model，兼容 Vue 2 和 Vue 3） */
  value?: string;
  modelValue?: string;
}
interface Emits {
  (e: 'input', value: string): void;
  (e: 'update:modelValue', value: string): void;
}
const __sfc_main = {};
__sfc_main.props = {
  options: {
    key: "options",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: String,
    default: ''
  },
  modelValue: {
    key: "modelValue",
    required: false,
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;

  /**
   * 当前选中的值（用于显示）
   * 兼容 Vue 2 (value) 和 Vue 3 (modelValue)
   * 如果值为空，显示第一个选项为选中（仅用于显示，不改变实际值）
   */
  const currentValue = computed(() => {
    const val = props.modelValue || props.value;
    return val || props.options[0]?.value || '';
  });

  /**
   * 处理标签选择
   * 同时触发 input 和 update:modelValue 事件以兼容 Vue 2 和 Vue 3
   */
  function handleSelect(value: string) {
    console.log('[TagSelector] handleSelect:', value);
    emit('input', value);
    emit('update:modelValue', value);
  }
  return {
    currentValue,
    handleSelect
  };
};
export default __sfc_main;
</script>

<style scoped>
/* 标签横向滚动容器 - 隐藏滚动条 */
.tag-selector::-webkit-scrollbar {
  display: none;
}
</style>
